"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BaseResourceChangeType () {
        return BaseResourceChangeType;
    },
    get BaseResourceLog () {
        return BaseResourceLog;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const BaseResourceChangeType = _zod.z.union([
    _zod.z.literal("create"),
    _zod.z.literal("update"),
    _zod.z.literal("delete")
]);
const BaseResourceLog = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    companyId: _utilsisomorphic.transformObjectId,
    resourceId: _utilsisomorphic.transformObjectId,
    changedBy: _utilsisomorphic.transformObjectId.nullable(),
    changedAt: _utilsisomorphic.transformDate,
    // Overridden by resource specific types
    resourceType: _zod.z.string(),
    changeType: _zod.z.string(),
    data: _zod.z.record(_zod.z.unknown())
});
